<template>
  <svg
    :width="size"
    :height="size"
    :style="{ color: color || undefined, '--icon-fill': filled ? 1 : 0, '--icon-state': state ? 1 : 0 }"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
  ><use :href="`${spritePath}#${name}`" /></svg>
</template>

<script setup>
// Ссылка на статический icon-sprite.svg (генерируется IconSpritePlugin —
// см. design-system/icons/) вместо инлайн <path> — на каждое использование
// иконки уходит ~60 байт разметки вместо полного дублированного path.
// Спрайт — обычный кэшируемый статик-ассет, вне Vue-дерева: никакого
// участия в SSR-гидрации.
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: [Number, String],
    default: 16,
  },
  // Символы в спрайте используют currentColor — без явного color наследуют
  // CSS color от родителя (обычные t-* классы дизайн-системы работают как есть)
  color: {
    type: String,
    default: null,
  },
  // Заливка иконки. Селекторы страницы внутрь <use> не проходят (символ живёт
  // в shadow-дереве), а CSS-переменные проходят: слой заливки символа читает
  // var(--icon-fill, 0) и сам анимирует переход — как ось FILL у Material Symbols.
  filled: {
    type: Boolean,
    default: false,
  },
  // Второе состояние иконки (глаз закрыт, звук выключен, сортировка по убыванию).
  // Что меняется, решает символ: его части читают var(--icon-state, 0).
  state: {
    type: Boolean,
    default: false,
  },
  // a11y: задать, если иконка несёт смысл сама по себе (не рядом с текстом-лейблом)
  label: {
    type: String,
    default: null,
  },
  // Путь к спрайту переопределяется проектом, если он лежит не в корне сайта
  spritePath: {
    type: String,
    default: '/icon-sprite.svg',
  },
});
</script>
